import React from 'react';
import { StoryblokComponent } from 'storyblok-js-client';
import { Props } from '../types';
import { filterProps, slottedToComponents } from '../helpers';

type RocheContactCard = StoryblokComponent<string> & {
  firstname: string;
  lastname: string;
  job_title: string;
  title: string;
  layout: string;
  slotted_links;
  slotted_media;
}

export const RocheContactCard = (
  { blok, getComponent, slot }: Props<RocheContactCard>,
): JSX.Element => {
  const { props, slotted } = filterProps(blok);
  const allProps = {
    ...props,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
  };

  return React.createElement('roche-contact-card', { ...allProps }, slottedToComponents(getComponent, slotted));
};
